import { Trans } from '@lingui/react/macro';
import { ChevronLeft } from '@untitledui/icons/ChevronLeft';

import { LinkButton } from '@/components/base/buttons/button';

import {
  forgetProjectOrigin,
  useProjectBackRoute,
} from '../-hooks/use-project-back-route';

export function BackButton({ projectId }: { projectId: string }) {
  const backRoute = useProjectBackRoute(projectId);

  return (
    <LinkButton
      to={backRoute}
      onClick={() => forgetProjectOrigin(projectId)}
      iconLeading={ChevronLeft}
      color="link-color"
      size="sm"
      className="text-md font-semibold"
    >
      <Trans>Back</Trans>
    </LinkButton>
  );
}
